import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, InputNumber, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { fieldsUnitTexts } from './utils/FieldsUnitTexts';
import { Text } from '@/components/Typography';

const { formatPlaceholderWithUnit } = fieldsUnitTexts;

interface PartialInputFieldProps {
	title?: string;
	unit?: string;
	fieldName: string[];
	isAddDisabled: boolean;
	onAdd: () => void;
}

export function PartialInputField(props: Readonly<PartialInputFieldProps>): JSX.Element {
	const { title, unit, fieldName, isAddDisabled, onAdd } = props;

	return (
		<Col span={24}>
			<Row gutter={[0, 5]}>
				<Col span={24}>
					<Text strong>{I18n.get(title)}</Text>
				</Col>
				<Col span={24}>
					<Row gutter={[8, 0]} align="middle">
						<Col flex="auto">
							<Form.Item style={{ margin: 0 }} name={fieldName}>
								<InputNumber
									min={0}
									style={{ width: '100%' }}
									placeholder={formatPlaceholderWithUnit('0', unit)}
								/>
							</Form.Item>
						</Col>
						<Col flex="none">
							<Button
								shape="circle"
								type="primary"
								icon={<PlusOutlined />}
								onClick={onAdd}
								disabled={isAddDisabled}
							/>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
}
